import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

const options = {}

Vue.use(VueFormulate, options)
